// extracted by mini-css-extract-plugin
export default {"blob":"Blob_blob__EQX2W","pulse":"Blob_pulse__Gr-zs"};